import Dropzone from "dropzone";
import 'pdfobject';

$(document).ready(function (e) {

    let attachments = [];
    let myDropzone

    if ($('#attachment-uploader').length) {
        myDropzone = new Dropzone("#attachment-uploader", {
            url: "/attachments",
            thumbnailWidth: 40, // px
            thumbnailHeight: 40,
            addRemoveLinks: false,
            maxFilesize: 25, // MB
            autoProcessQueue: true,
            parallelUploads: 10,
            uploadMultiple: true,
            previewTemplate: `<div class="dz-preview dz-file-preview">
                                <div class="dz-details">
                                    <div class="row">
                                        <div class="col-7">
                                            <div class="row">
                                                <div class="col-10 upload-details" >
                                                    <b data-dz-name></b>
                                                </div>
                                                <div class="col-2">
                                                    <i class="fa fa-times remove-attachments" data-dz-remove></i>
                                                </div>
                                            </div>
                                        </div>
        
                                        <div class="col-5">
                                            <div class="upload-progress">
                                                <span class="dz-progress">
                                                    <span class="dz-upload" data-dz-uploadprogress></span>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>`
        });

        myDropzone.on("sending", (file, xhr, formData) => {
            let $attachment_container = $('.attachment-container'),
                record_id = $attachment_container.attr('data-record-id'),
                table_id = $attachment_container.attr('data-table-id');
            formData.append('_token', $('meta[name="csrf-token"]').attr('content'));
            formData.append('record_id', record_id);
            formData.append('table_id', table_id);
        });

        // Remove all uploaded files, reload table and
        // show success toastr.
        myDropzone.on("successmultiple", (files, responseText) => {
            myDropzone.removeAllFiles();
            refreshAttachmentsTable();
            $('.upload-message').addClass('d-none');
            toastr.success('Attachments uploaded', '', {timeOut: 5000});
        });


        myDropzone.on("addedfile", (files) => {
            $('.upload-message').removeClass('d-none');
        });

        // Remove file
        myDropzone.on("removedfile", (files) => {
            if (!myDropzone.getQueuedFiles().length) {
                $('.upload-message').addClass('d-none');
            }
        });

        // In case of error, display toastr
        myDropzone.on("error", (file, message) => {
            toastr.error(file.name, message, {timeOut: 5000});
        });

        refreshAttachmentsTable(true);
    }


    function refreshAttachmentsTable(loadJson = false) {
        let $attachment_container = $('.attachment-container');
        let section_id = $attachment_container.attr('data-section-id'),
            record_id = $attachment_container.attr('data-record-id'),
            table_id = $attachment_container.attr('data-table-id');

        loadJson = loadJson ? 1 : 0
        $.ajax({
            type: 'GET',
            url: '/attachments',
            data: {
                record_id,
                table_id,
                section_id,
                loadJson
            },
            success: function (res) {
                if (!loadJson) {
                    $attachment_container.html(res);
                } else {
                    attachments = res;
                }
            },
            error: function (res) {
            }
        })
    }

    $('.show-attachment-modal').on('click', function (e) {
        e.preventDefault();
        $('#attachment-modal').modal('show');
    });

    $('#upload-attachment').on('click', function (e) {
        if (myDropzone.getRejectedFiles().length) {
            myDropzone.getRejectedFiles().forEach((file, index) => {
                toastr.error(`Unable to upload ${file.name}`, '', {timeOut: 5000});
            });
        }
        myDropzone.processQueue();
    });

    $('.delete-attachments').on('click', function (e) {
        e.preventDefault();
        let table_id = $(this).attr('data-owner-table'),
            record_id = $(this).attr('data-owner-record'),
            attachments = [];

        let $container = $(this).parents('.tbl-section');

        $container.find(".sub_chk:checked").each(function () {
            attachments.push($(this).attr('data-id'));
        });

        if (attachments.length <= 0) {
            alert("Please select at least one attachment to delete.");
        } else {
            if (confirm("Are you sure, you want to delete the selected attachment?")) {
                $.ajax({
                    url: "/attachments",
                    type: 'DELETE',
                    data: {
                        attachments: attachments
                    },
                    success: function (res) {
                        attachments.forEach(id => {
                            $container.find('.sub_chk[data-id="' + id + '"]').each(function () {
                                $(this).parents("tr").remove();
                            });
                        });
                    }
                });
            }
        }
    });

    $(document).on('click', '.delete-attachment', function (e) {
        e.preventDefault();
        let attachment_id = $(this).attr('data-attachment-id');
        let $container = $(this).parents('.tbl-section'),
            attachments = [attachment_id];

        if (confirm("Are you sure, you want to delete the selected attachment?")) {
            $.ajax({
                url: "/attachments",
                type: 'DELETE',
                data: {
                    attachments: attachments
                },
                success: function (res) {
                    attachments.forEach(id => {
                        $container.find('.sub_chk[data-id="' + id + '"]').each(function () {
                            $(this).parents("tr").remove();
                        });
                    });
                }
            });
        }
    });

    $(document).on('click', '.view-attachment', function (e) {
        e.preventDefault();
        let path = $(this).attr('data-path'),
            ext = $(this).attr('data-ext'),
            index = $(this).attr('data-index'),
            name = $(this).attr('data-name');
        open_attachment(path, ext, index, name);
    });

    var index = 0;

    function open_attachment(attachment_url, type, _index = null, original_name) {
        if (_index != null) {
            index = _index;
        }

        if (type == "jpg" || type == "png" || type == "jpeg" || type == "gif") {
            $("#document-container").html('<img src="' + attachment_url + '" style="max-width:100%;max-height: 85vh;"/>');
        } else if (type == "pdf") {
            let timestamp = new Date().getTime();
            $("#document-container").html('<object type="application/pdf" data="' + attachment_url + '?t=' + timestamp + '" style="height:85vh;width:100%;">No Support. Please open the pdf in new tab.</object>');
        } else if (type == "docx") {
            $("#document-container").html('<img src="' + attachment_url + 'img/docx.jpg" />');
        } else if (type == "zip") {
            $("#document-container").html('<img src="' + attachment_url + 'img/zip.jpg"/>');
        } else if (type == "xlsx") {
            $("#document-container").html('<img src="' + attachment_url + 'img/xlsx.jpg"/>');
        } else if (type == "mp4") {
            $("#document-container").html('<img src="' + attachment_url + 'img/mp4.jpg"/>');
        } else if (type == "txt") {
            $("#document-container").html('<iframe src=" ' + attachment_url + '"  style="height:85vh;width:100%;"/>');
        }
        $("#attachment-preview-btn").attr('href', attachment_url);
        $("#attachment-download-btn").attr('download', original_name);
        $("#attachment-download-btn").attr('href', attachment_url);
        //open the modal
        $("#viewer-modal").modal('show');
    }

    $('.next-btn').click(function () {

        if (index == (attachments.length - 1)) {
            index = 0;
        } else {
            index++;
        }
        var type = null;

        attachments[index].extension = attachments[index].extension.toLowerCase();

        if (
            attachments[index].extension == 'jpg' ||
            attachments[index].extension == 'png' ||
            attachments[index].extension == 'jpeg' ||
            attachments[index].extension == 'gif'
        ) {
            type = "image";
        } else if (attachments[index].extension == 'pdf') {
            type = "pdf";
        } else if (attachments[index].extension == 'docx') {
            type = "docx";
        } else if (attachments[index].extension == 'zip') {
            type = "zip";
        } else if (attachments[index].extension == 'xlsx') {
            type = "xlsx";
        } else if (attachments[index].extension == 'mp4') {
            type = "mp4";
        } else if (attachments[index].extension == 'txt') {
            type = "txt";
        }
        if (type != null) {
            open_attachment('/storage/' + attachments[index].path, attachments[index].extension, null, attachments[index].original_name)
        }

    });

    $('.prev-btn').click(function () {
        if (index == 0) {
            index = attachments.length - 1;
        } else {
            index--;
        }

        var type = null;

        if (
            attachments[index].extension == 'jpg' ||
            attachments[index].extension == 'png' ||
            attachments[index].extension == 'jpeg' ||
            attachments[index].extension == 'gif'
        ) {
            type = "image";
        } else if (attachments[index].extension == 'pdf') {
            type = "pdf";
        } else if (attachments[index].extension == 'docx') {
            type = "docx";
        } else if (attachments[index].extension == 'zip') {
            type = "zip";
        } else if (attachments[index].extension == 'xlsx') {
            type = "xlsx";
        } else if (attachments[index].extension == 'mp4') {
            type = "mp4";
        } else if (attachments[index].extension == 'txt') {
            type = "txt";
        }

        if (type != null) {
            open_attachment('/storage/' + attachments[index].path, type, null, attachments[index].original_name)
        }
    });

    $('#enable_attachments').on('change', function (e) {
        let enable = parseInt($(this).val());

        if (enable) {
            $('.webform-attach-container').removeClass('d-none');
        } else {
            $('.webform-attach-container').addClass('d-none');
        }
    })
});
